import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete as MaterialAutocomplete } from '@material-ui/lab';
import { TextField as MaterialTextField } from '@material-ui/core';
import { omit } from 'lodash-es';
import { useTheme } from '@material-ui/core/styles';

import { fieldLabel } from 'core/helpers/sentence-case';

import deleteIcon from './delete-icon.svg';
import chevronIcon from './chevron-icon.svg';

const Autocomplete = (props) => {
  const {
    id = '',
    name = '',
    inputProps: fieldProps = {},
    InputProps: MuiInputProps = {},
    onBlur = () => {},
    onSelection = () => {},
    options = [],
    value = '',
    className = '',
    InputComponent = MaterialTextField,
    showChevronIcon,
    showDeleteIcon,
    ...restProps
  } = props;
  const theme = useTheme();

  return (
    <MaterialAutocomplete
      fullWidth
      freeSolo
      openOnFocus
      id={id}
      options={options}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.text || '')}
      closeIcon={showDeleteIcon ? <img src={deleteIcon} alt="delete" /> : null}
      forcePopupIcon={showChevronIcon}
      popupIcon={showChevronIcon ? <img src={chevronIcon} alt="chevron" /> : null}
      onChange={onSelection}
      value={value}
      renderInput={(params) => {
        const { InputProps, InputLabelProps, ...restParams } = params;

        // We omit default material's className so it doesn't mess up our custom TextField styles
        const InputPropsWithoutClass = omit(InputProps, ['className']);
        return (
          <InputComponent
            {...restParams}
            {...fieldProps}
            label={fieldLabel(theme, fieldProps.label)}
            className={className}
            InputProps={{ ...InputPropsWithoutClass, ...MuiInputProps }}
            key={id}
            name={name || id}
            onBlur={onBlur}
            labelProps={InputLabelProps}
          />
        );
      }}
      {...restProps}
    />
  );
};

Autocomplete.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  InputComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.node, PropTypes.element]),
  onBlur: PropTypes.func,
  options: PropTypes.array,
  onSelection: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
  showChevronIcon: PropTypes.oneOf(['auto', true, false]),
  showDeleteIcon: PropTypes.bool
};

Autocomplete.defaultProps = {
  showChevronIcon: 'auto',
  showDeleteIcon: false
};

export default Autocomplete;
